// extracted by mini-css-extract-plugin
export default {"item":"DeductionsHistoryList_item__fLlbq","success":"DeductionsHistoryList_success__EzD2U","icon":"DeductionsHistoryList_icon__l536R","filled":"DeductionsHistoryList_filled__KsTxx"};